import React, {useContext} from "react";
import AppContext from "../framework/AppContext";
import UnregisteredResearcherHome from "../UnregisteredResearcherHome";
import {ResearcherStatus} from "../researcher/model/ResearcherStatus";

/**
 * This is the home page of the application. There are 3 different views we can have:
 * <ul>
 *   <li>AMT view</li>
 *   <li>Researcher view</li>
 *   <li>Unregistered researcher view</li>
 * </ul>
 */
export default function HomePage() {
  const context = useContext(AppContext);

  // Show unregistered home page if researcher hasn't yet registered
  if (context?.userProfile?.researcherStatus !== ResearcherStatus.APPROVED) {
    return <div className="content-section menu-page">
      <UnregisteredResearcherHome/>
    </div>;
  }

  // TODO Implement researcher and AMT home page views
  return <>Welcome to the home page!</>;
}